import React from 'react';

const ProductCard = ({ product, onClick }) => {
    return (
        <div
            className="group relative bg-dark-800 rounded-xl overflow-hidden border border-white/5 shadow-lg hover:shadow-glow-orange transition-all duration-500 cursor-pointer"
            onClick={() => onClick(product)}
        >
            {/* Image Container */}
            <div className="h-64 overflow-hidden relative">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent opacity-60" />

                {/* Overlay Button */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-dark-900/40 backdrop-blur-sm">
                    <span className="px-6 py-2 border border-royal-500 text-royal-500 font-bold uppercase tracking-wider text-sm bg-dark-900/80 rounded hover:bg-royal-500 hover:text-white transition-colors">
                        View Details
                    </span>
                </div>
            </div>

            {/* Content */}
            <div className="p-6 relative">
                <div className="absolute top-0 right-6 -translate-y-1/2 w-12 h-12 bg-royal-600 rounded-full flex items-center justify-center shadow-lg group-hover:bg-royal-500 transition-colors">
                    <span className="text-xl">➜</span>
                </div>

                <p className="text-royal-500 text-xs font-bold uppercase tracking-widest mb-2">
                    {product.category}
                </p>
                <h3 className="text-xl font-display font-bold text-white mb-2 group-hover:text-royal-400 transition-colors">
                    {product.name}
                </h3>
            </div>
        </div>
    );
};

export default ProductCard;
